/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamShapingGroupCircularDto } from './BeamShapingGroupCircularDto';
import {
    instanceOfBeamShapingGroupCircularDto,
    BeamShapingGroupCircularDtoFromJSON,
    BeamShapingGroupCircularDtoFromJSONTyped,
    BeamShapingGroupCircularDtoToJSON,
} from './BeamShapingGroupCircularDto';
import type { BeamShapingGroupRectangularDto } from './BeamShapingGroupRectangularDto';
import {
    instanceOfBeamShapingGroupRectangularDto,
    BeamShapingGroupRectangularDtoFromJSON,
    BeamShapingGroupRectangularDtoFromJSONTyped,
    BeamShapingGroupRectangularDtoToJSON,
} from './BeamShapingGroupRectangularDto';
import type { DiscreteNumericValueDto } from './DiscreteNumericValueDto';
import {
    instanceOfDiscreteNumericValueDto,
    DiscreteNumericValueDtoFromJSON,
    DiscreteNumericValueDtoFromJSONTyped,
    DiscreteNumericValueDtoToJSON,
} from './DiscreteNumericValueDto';
import type { ElectronBeamQualityCombinationValueDto } from './ElectronBeamQualityCombinationValueDto';
import {
    instanceOfElectronBeamQualityCombinationValueDto,
    ElectronBeamQualityCombinationValueDtoFromJSON,
    ElectronBeamQualityCombinationValueDtoFromJSONTyped,
    ElectronBeamQualityCombinationValueDtoToJSON,
} from './ElectronBeamQualityCombinationValueDto';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    instanceOfEnumerationValueDto,
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { FaultyNumericValueDto } from './FaultyNumericValueDto';
import {
    instanceOfFaultyNumericValueDto,
    FaultyNumericValueDtoFromJSON,
    FaultyNumericValueDtoFromJSONTyped,
    FaultyNumericValueDtoToJSON,
} from './FaultyNumericValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    instanceOfNumericValueDto,
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';
import type { PhotonBeamQualityCombinationValueDto } from './PhotonBeamQualityCombinationValueDto';
import {
    instanceOfPhotonBeamQualityCombinationValueDto,
    PhotonBeamQualityCombinationValueDtoFromJSON,
    PhotonBeamQualityCombinationValueDtoFromJSONTyped,
    PhotonBeamQualityCombinationValueDtoToJSON,
} from './PhotonBeamQualityCombinationValueDto';
import type { TextValueDto } from './TextValueDto';
import {
    instanceOfTextValueDto,
    TextValueDtoFromJSON,
    TextValueDtoFromJSONTyped,
    TextValueDtoToJSON,
} from './TextValueDto';

/**
 * @type ISystemSetupCombinationValue
 * 
 * @export
 */
export type ISystemSetupCombinationValue = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & DiscreteNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & FaultyNumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ElectronBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & ElectronBeamQualityCombinationValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.PhotonBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & PhotonBeamQualityCombinationValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamShapingGroupCircularDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamShapingGroupRectangularDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TextValueDto;


export function ISystemSetupCombinationValueFromJSON(json: any): ISystemSetupCombinationValue {
    return ISystemSetupCombinationValueFromJSONTyped(json, false);
}

export function ISystemSetupCombinationValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISystemSetupCombinationValue {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, DiscreteNumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, FaultyNumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ElectronBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, ElectronBeamQualityCombinationValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ElectronBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.PhotonBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, PhotonBeamQualityCombinationValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.PhotonBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, BeamShapingGroupCircularDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, BeamShapingGroupRectangularDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TextValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of ISystemSetupCombinationValue exists with '$type=${json['$type']}'`);
    }
}

export function ISystemSetupCombinationValueToJSON(value?: ISystemSetupCombinationValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return DiscreteNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return FaultyNumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ElectronBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ElectronBeamQualityCombinationValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.PhotonBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return PhotonBeamQualityCombinationValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamShapingGroupCircularDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamShapingGroupRectangularDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TextValueDtoToJSON(value);
        default:
            throw new Error(`No variant of ISystemSetupCombinationValue exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ISystemSetupCombinationValue interface.
 */
export function instanceOfISystemSetupCombinationValue(value: any): value is ISystemSetupCombinationValue {
    if (instanceOfEnumerationValueDto(value)) return true;
    if (instanceOfDiscreteNumericValueDto(value)) return true;
    if (instanceOfFaultyNumericValueDto(value)) return true;
    if (instanceOfNumericValueDto(value)) return true;
    if (instanceOfElectronBeamQualityCombinationValueDto(value)) return true;
    if (instanceOfPhotonBeamQualityCombinationValueDto(value)) return true;
    if (instanceOfBeamShapingGroupCircularDto(value)) return true;
    if (instanceOfBeamShapingGroupRectangularDto(value)) return true;
    if (instanceOfTextValueDto(value)) return true;
    return false;
}

